import { render, staticRenderFns } from "./AlertasModal.vue?vue&type=template&id=7f5fc3b6"
import script from "./AlertasModal.vue?vue&type=script&lang=js"
export * from "./AlertasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports